import { render, staticRenderFns } from "./Cabinets.vue?vue&type=template&id=42e31e7e&scoped=true"
import script from "./Cabinets.vue?vue&type=script&lang=js"
export * from "./Cabinets.vue?vue&type=script&lang=js"
import style0 from "./Cabinets.vue?vue&type=style&index=0&id=42e31e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e31e7e",
  null
  
)

export default component.exports